module.exports = __webpack_public_path__ + "img/about-2.c4b4e28d.jpg";